export const TopNavigationRendererEnum =
{
    basic: 'basic',
    animated: 'animated'
};